<template>
    <HomeLayout :isShowDelivery="false">
        <div class="p-4">
            <ProfileContent></ProfileContent>
        </div>
    </HomeLayout>
</template>
<script>
import Util from '@/helper/Utility.js';
import HomeLayout from '@/components/Layout/Page/HomeLayout.vue'
import ProfileContent from '../component/ProfileContent/ProfileContent.vue';

export default {
    components: {
        HomeLayout,
        ProfileContent,
    },
    created() {
        this.tracking.screenName('moremenu');
        this.tracking.event('moremenu','view_more_menu',null,null);
    },
    mounted: function () {
        Util.scrollTop();
    },
}
</script>
<style lang="scss" scoped>
</style>
